import { hiringScheduleInterviewsQuery } from "domains/hire/containers/HiringScheduleCalendar/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: { calendarDate: Date }): Array<WarmableQuery> => [hiringScheduleInterviewsQuery(input)];
